import React, { useState } from 'react';
import { Project } from '../../types/project';
import { ProjectTable } from './ProjectTable';
import { NewProjectModal } from './NewProjectModal';
import { useIsInternalUser } from '../../hooks/useIsInternalUser';
import { useIsAccessIdUser } from '../../hooks/useIsAccessIdUser';

interface AllProjectsTabProps {
  projects: Project[];
}

export function AllProjectsTab({ projects }: AllProjectsTabProps) {
  const [showNewProject, setShowNewProject] = useState(false);
  const isInternalUser = useIsInternalUser();
  const isAccessIdUser = useIsAccessIdUser();
  // AccessID org members (non-internal) create projects in AccessID instead.
  const canCreateProject = isInternalUser || !isAccessIdUser;

  return (
    <>
      <h2 data-testid="project-list-all-heading">
        <i className="fas fa-gavel" aria-hidden="true" /> All Projects
        <button
          className="btn btn-primary pull-right"
          data-testid="project-list-add-btn"
          disabled={!canCreateProject}
          title={canCreateProject ? undefined : 'Projects should be created from AccessID'}
          onClick={() => setShowNewProject(true)}
        >
          Add a project <i className="fas fa-plus-circle" aria-hidden="true" style={{ color: '#fff' }} />
        </button>
      </h2>
      <ProjectTable projects={projects} />
      {showNewProject && (
        <NewProjectModal onClose={() => setShowNewProject(false)} />
      )}
    </>
  );
}
